import { connect } from 'react-redux';

import { getActiveScriptType } from 'current/selectors';

import PlantingPlan from './PlantingPlan';

export default connect(
  (state) => ({
    scriptType: getActiveScriptType(state)
  })
)(PlantingPlan);
